import React from "react";
import { DOMNode, domToReact } from "html-react-parser";
import { createReplacer } from "./Replacer";

const removeElementButKeepChildren = createReplacer({
  supports({ attribs, name }) {
    return (
      name === "div" &&
      (attribs?.id === "content-wrapper" || attribs?.class === "relative")
    );
  },
  replace({ children }, options) {
    return <>{domToReact(children as DOMNode[], options)}</>;
  },
});

export default removeElementButKeepChildren;
